import React, { useEffect, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import ChooseAddressComponent from 'components/ChooseAddress/ChooseAddress';
import { Title } from 'components/Text';
import AddressTypes from 'constants/addressTypes';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import deliveryAddress, { isAddressFormValid } from 'state/address';
import { chosenAgreement as chosenAgreementAtom } from 'state/agreement';
import useAddressForm from 'utils/form/useAddressForm';
import jsonEqual from 'utils/general/jsonEquals';
export default function ChooseAddress() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const chosenAgreement = useRecoilValue(chosenAgreementAtom);
  const defaultAddress = chosenAgreement?.shippingAddress ?? customer?.shippingAddress ?? customer?.customerAddress;
  const [address, setAddress] = useRecoilState(deliveryAddress);
  const setIsAddressFormValid = useSetRecoilState(isAddressFormValid);
  const addressForm = useAddressForm(undefined);
  const {
    watch,
    formState: {
      isValid
    }
  } = addressForm;
  const customAddress = watch();
  const [currentAddressType, setCurrentAddressType] = useState(AddressTypes.CUSTOMER);
  const isCustomAddress = currentAddressType === AddressTypes.SPECIFIC;
  useEffect(() => {
    const newAddress = isCustomAddress ? customAddress : defaultAddress;
    if (!jsonEqual(newAddress, address)) setAddress(newAddress);
  }, [isCustomAddress, customAddress, defaultAddress, setAddress, address]);
  useEffect(() => {
    setIsAddressFormValid(!isCustomAddress || isValid);
  }, [isCustomAddress, isValid, setIsAddressFormValid]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    isBold: true
  }, t('register_vehicle.select_delivery_address')), /*#__PURE__*/React.createElement(FormProvider, addressForm, /*#__PURE__*/React.createElement(ChooseAddressComponent, {
    defaultAddress: defaultAddress,
    currentAddressType: currentAddressType,
    setCurrentAddressType: setCurrentAddressType
  })));
}